module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBestseller@2x.52f6849.webp";